// extracted by mini-css-extract-plugin
export var chip = "_dv-0";
export var filterDropdown = "_dv-5";
export var filterItem = "_dv-6";
export var icon = "_dv-1";
export var removeButton = "_dv-3";
export var removeIcon = "_dv-4";
export var separator = "_dv-2";